module.exports = __webpack_public_path__ + "img/badge-3.0e1c34ab.svg";